<script lang="ts">
  import { fly } from 'svelte/transition';
  import { ConfigStore } from '../../store/config';
  import { elasticInOut } from 'svelte/easing';
</script>

<div
  class="cs-greeting-theme-wrapper"
  in:fly|global={{
    y: 5,
    duration: 2000,
    easing: elasticInOut,
  }}
>
  <img
    src={$ConfigStore.agentImg}
    alt={$ConfigStore.productName}
    class="cs-greeting-theme-image"
  />
</div>

<style lang="scss">
  @use './../../../scss/components/themes/_greeting-theme';
</style>
